import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitized: DomSanitizer) { }

  public transform(value: string) {
    if (!value) {
      return value;
    }

    const decodedValue = this.decodeHtmlEntities(value);
    return this.sanitized.bypassSecurityTrustHtml(decodedValue);
  }

  private decodeHtmlEntities(text: string): string {
    let decoded = text;
    const textArea = document.createElement('textarea');

    for (let i = 0; i < 3; i++) {
      textArea.innerHTML = decoded;
      const newDecoded = textArea.value;
      if (newDecoded === decoded) {
        break;
      }
      decoded = newDecoded;
    }

    return decoded;
  }
} 
